// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Dropzone_dropzone__1mkSe","highlight":"Dropzone_highlight__138TY","disabled":"Dropzone_disabled__33chR"};